module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-introduction/i2-6-638c3a1db46af574e42df97a092c5310.svg";